import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import { DemoNumber, DemoPoint, DemoPointIcon } from './ListDemo'
import ListElement from './ListElement'
import ListFormBrand from './ListFormBrand'
import { STYLE_FORM_SCHEMA } from './ListFormStyle'
import ListFormValue from './ListFormValue'
import icon from './assets/list.svg'

export default genElementConfig(CONFIG_ELEMENTS.list, {
  label: t('elements.list.label'),
  icon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: ListElement,
  Demo: [DemoNumber, DemoPoint, DemoPointIcon],
  FormValue: ListFormValue,
  FormBrand: ListFormBrand,
  EditorActions: EditableProMode,
})
